import { render } from "./bootcampNotes.vue?vue&type=template&id=5bdbc2e9&scoped=true"
import script from "./bootcampNotes.vue?vue&type=script&lang=js"
export * from "./bootcampNotes.vue?vue&type=script&lang=js"

import "./bootcampNotes.vue?vue&type=style&index=0&id=5bdbc2e9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdbc2e9"]])

export default __exports__